/** Порядок как PHP Fingerprint::ALLOWED / Go fingerprint.Allowed */
export const FINGERPRINT_OPTIONS = [
  'chrome',
  'firefox',
  'safari',
  'ios',
  'android',
  'edge',
  '360',
  'qq',
  'random',
  'randomized',
] as const

export const DEFAULT_FINGERPRINT: FingerprintOption = 'firefox'

export type FingerprintOption = (typeof FINGERPRINT_OPTIONS)[number]

export const RISK_CONSENT_YES = 'YES'

const riskFingerprints = new Set<string>(['random', 'randomized'])

export function requiresRiskConsent(value: string): boolean {
  return riskFingerprints.has(value)
}

export const FINGERPRINT_RISK_COPY = {
  random: {
    title: 'Выбор случайного профиля браузера',
    body: 'При выборе random система будет случайным образом подбирать один из профилей uTLS при каждом подключении.',
    consequences:
      'В пул входят китайские браузеры (360, QQ) — профиль может быть менее распространённым, что теоретически может привлечь внимание к сессии и вызвать подозрения у DPI-систем в вашей юрисдикции.',
  },
  randomized: {
    title: 'Синтетическая генерация отпечатка',
    body: 'При выборе randomized система генерирует ClientHello «с нуля», случайно комбинируя TLS-расширения и шифры. Полученный отпечаток не соответствует ни одному реальному браузеру.',
    consequences:
      'Сгенерированная комбинация расширений может быть физически невозможной для реального браузера — это маркер для DPI-систем и может привести к блокировке или деградации соединения.',
  },
} as const

export type RiskFingerprint = keyof typeof FINGERPRINT_RISK_COPY
